import script from "./ClientCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientCard.vue?vue&type=script&setup=true&lang=ts"

import "./ClientCard.vue?vue&type=style&index=0&id=87cb2050&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87cb2050"]])

export default __exports__